import PropTypes from "prop-types";
import React from "react";
import ImageLoader from "react-imageloader";
import Placeholder from "../../../pois/components/placeholder";

function ListItemImage({ image, title, style, aspectRatio = 5 / 4 }) {
  const renderPlaceholder = () => (
    <Placeholder
      title={title}
      fontSize={50}
      aspectRatio={aspectRatio}
      style={style}
    />
  );

  return (
    <ImageLoader
      src={image.path}
      preloader={() => renderPlaceholder(title)}
      imgProps={{ style }}
    >
      {renderPlaceholder(title)}
    </ImageLoader>
  );
}

ListItemImage.propTypes = {
  /**
   * Aspect ratio of the placeholder
   */
  aspectRatio: PropTypes.number,
  /**
   * The name of the POI
   * key: name
   */
  title: PropTypes.string.isRequired,
  /**
   * Image src for the POI; required keys are path and orientation
   * partner-activities key: links.image
   */
  image: PropTypes.object,

  /**
   * Styling for the placeholder and img element
   */
  style: PropTypes.object,
};

export default ListItemImage;



// WEBPACK FOOTER //
// ./assets/shared/components/listItemImage/index.jsx